module.exports = __webpack_public_path__ + "img/Vector25.b9371f7d.svg";